import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import BirthDatePicker from './BirthDatePicker';
import { Moment } from 'moment';

interface Props extends BaseFieldProps {
	value?: Moment | string | null;
	onChange?: (date: string | null) => void;
	disabled?: boolean;
	minDate?: Moment;
	maxDate?: Moment;
}

const BirthDatePickerField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<BirthDatePicker
				value={props.value}
				onChange={props.onChange}
				disabled={props.disabled}
				maxDate={props.maxDate}
				minDate={props.minDate}
			/>
		</BaseField>
	);
};

export default BirthDatePickerField;
